module.exports = __webpack_public_path__ + "static/media/blaze_retail_logo.d08a0386.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blaze_retail_logo.svg
// module id = 2428
// module chunks = 0